import FAQRepository from '@/repositories/FAQRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'

export interface IFetchFAQContentUseCaseParams {
  FAQRepository: FAQRepository
  snapsnapGateway: SnapsnapGateway
}

export default class FetchFAQContentUseCase implements BaseUseCase {
  FAQRepository: FAQRepository
  snapsnapGateway: SnapsnapGateway

  constructor({ FAQRepository, snapsnapGateway }: IFetchFAQContentUseCaseParams) {
    this.FAQRepository = FAQRepository
    this.snapsnapGateway = snapsnapGateway
  }

  async execute(contentId: number) {
    try {
      const content = await this.snapsnapGateway.FAQ.getContent(contentId)
      this.FAQRepository.saveContent(content)
    } catch (error) {
      throw error
    }
  }
}
